/* eslint-disable */
import React, {useState} from 'react';
//css
import 'contents/assets/scss/page/accounting.scss';
//component
import Tab from '../../component/Inc/Tab';
import PopRefund from '../accounting/_PopRefund';
import PopRefundApproval from '../accounting/_PopRefundApproval';

function AccountingRefund() {
  const [modalRefund, setRefund] = useState(false);
  const [modalRefundApproval, setRefundApproval] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab01 = [
    {title: '전체', value: 0},
    {title: '환불신청', value: 1},
    {title: '승인불가', value: 2},
    {title: '재검토 요청', value: 3},
    {title: '승인 완료', value: 4}
  ];
  return (
    <main className="com_container p_refund">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_4 active">환불 관리</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tablStyle="fit_cont" />
         
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn lightGray s">내 환불 요청</button>
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <div className="com_count_wrapper">
                  <div className="operators">
                    <div className="operators_label">
                      <span className="operators_count">총 입금 건수</span>
                      <span className="operators_value">98건</span>
                    </div>
                  </div>
                  <div className="turnover">
                    <div className="turnover_label">
                      <span className="turnover_count">총 입금액</span>
                      <span className="turnover_value">46,500,000</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="120" />
                <col width="80" />
                <col width="80" />
                <col width="80" />
                <col width="80" />
                <col width="80" />
                <col width="100" />
                <col width="90" />
                <col width="90" />
                <col width="90" />
                <col width="90" />
                <col width="auto" />
                <col width="90" />
                <col width="90" />
                <col width="90" />
              </colgroup>
              <thead>
                <tr>
                  <th>선택</th>
                  <th>요청일</th>
                  <th>학생</th>
                  <th>과목</th>
                  <th>상품가격</th>
                  <th>진행회차</th>
                  <th>총 결제액</th>
                  <th>환불사유</th>
                  <th>환불요청액</th>
                  <th>위약금</th>
                  <th>
                    수수료<span className="sub">(담임이 지불)</span>
                  </th>
                  <th>최종 환불액</th>
                  <th>환불 처리일</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>수정</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                    <label htmlFor="chk010"></label>
                  </td>
                  <td>2022, 08, 25</td>
                  <td>
									  <button className="btn_link txt" onClick={() => setRefundApproval(true)}>
									  김학생103
                    </button>
									</td>
                  <td>과탐</td>
                  <td>466,000</td>
                  <td>12/16</td>
                  <td>45,000</td>
                  <td>결제 방식 변경</td>
                  <td>150,000</td>
                  <td className="td_red">132,000</td>
                  <td className="td_red">-</td>
                  <td className="td_red">789,000</td>
                  <td className="td_red">
                    <button className="btn_link txt" onClick={() => setRefund(true)}>
                      환불요청
                    </button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>
                    <button className="btn_link">홍담임103</button>
                  </td>
                  <td className="td_point">
                    <button className="btn_link txt">수정</button>
                  </td>
                </tr>
                {[...Array(3)].map((i, idx) => (
                  <tr key={idx}>
                    <td>
                      <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                      <label htmlFor="chk010"></label>
                    </td>
                    <td>2022, 08, 25</td>
                    <td><button className="btn_link">김학생103</button></td>
                    <td>과탐</td>
                    <td>466,000</td>
                    <td>12/16</td>
                    <td>45,000</td>
                    <td>결제 방식 변경</td>
                    <td>150,000</td>
                    <td className="td_red">132,000</td>
                    <td className="td_red">-</td>
                    <td className="td_red">789,000</td>
                    <td className="td_point">
                      <button className="btn_link txt">2022, 08, 20 11:30</button>
                    </td>
                    <td>
                      <button className="btn_link">홍길동103</button>
                    </td>
                    <td>
                      <button className="btn_link">홍담임103</button>
                    </td>
                    <td className="td_point">
                      <button className="btn_link txt">수정</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </div>
        </section>
      </div>
      <PopRefund open={modalRefund} close={() => setRefund(false)} />
      <PopRefundApproval open={modalRefundApproval} close={() => setRefundApproval(false)} />
			
    </main>
  );
}

export default AccountingRefund;
